import { ClickEvent, Label, OpenType, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDrsDeductEarningHist } from "./autogen/AutogenLayoutDrsDeductEarningHist";
import { OrderTabView } from "@mcleod/dispatch";
import { Navigation, StringUtil } from "@mcleod/core";
import { LabelStyles } from "@mcleod/components/src/components/label/LabelStyles";

export class DrsDeductEarningHist extends AutogenLayoutDrsDeductEarningHist {

    onLoad(): void | Promise<void> {
        this.tableDeduction.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
    }

    orderNumberOnClick(event: ClickEvent) {
        const orderOrManifestId = (event.target as Label)?.text;
        if (!StringUtil.isEmptyString(orderOrManifestId)) {
            if (orderOrManifestId?.startsWith("M")) {
                Navigation.navigateTo("lme/dispatch/OrderList?manifest_id=" + orderOrManifestId, { newTab: true });
            } else {
                OrderTabView.navigateTo({ key: orderOrManifestId, newTab: true });
            }
        }
    }

    tableDeductionOnRowDisplay(event: TableRowDisplayEvent){
        const tableRow = event.getTableRow();
        const orderIdLabel = tableRow.findComponentById("labelOrderNumber") as Label;
        if (orderIdLabel != null && !StringUtil.isEmptyString(orderIdLabel.text)) {
            if (orderIdLabel.text?.startsWith("M")) {
                orderIdLabel.tooltip = "Click to view manifest";
            } else {
                orderIdLabel.tooltip = "Click to view order";
            }
            orderIdLabel.setClassIncluded(LabelStyles.link, true);
            orderIdLabel.addUnderlineWhenMouseOver();
            orderIdLabel.addClickListener((event: ClickEvent) => this.orderNumberOnClick(event));
        }
    }
}
